import { DatePicker, Input, Select, Text, type TypeSelectOption } from '@thefarmersfront/kitchen';

import clsx from 'clsx';
import dayjs from 'dayjs';

import { SearchFilter } from '~/components/common';

import { getDateByOffset } from '~/utils/date';

import { OPTION_ALL } from '~/constants';

import type {
  TypeDeliveryAgencyOutboundUnitSearchBoxOptions,
  TypeDeliveryAgencyOutboundUnitSearchBoxValues,
  TypeDeliveryAgencyOutboundUnitSearchBoxValuesStatus,
} from '~/types/delivery-agency.types';

import styles from './DeliveryAgencyOutboundUnitSearchBox.module.scss';

const DeliveryAgencyOutboundUnitSearchBox = ({
  options,
  values,
  valuesStatus,
  onChange,
  onChangeStatus,
  onSearch,
  onReset,
}: {
  options: TypeDeliveryAgencyOutboundUnitSearchBoxOptions;
  values: TypeDeliveryAgencyOutboundUnitSearchBoxValues;
  valuesStatus: TypeDeliveryAgencyOutboundUnitSearchBoxValuesStatus;
  onChange: (values: Partial<TypeDeliveryAgencyOutboundUnitSearchBoxValues>) => void;
  onChangeStatus: (values: Partial<TypeDeliveryAgencyOutboundUnitSearchBoxValuesStatus>) => void;
  onSearch: () => void;
  onReset: () => void;
}) => {
  return (
    <SearchFilter formId="delivery-agency-outbound-unit-search-form" onSubmit={onSearch} onReset={onReset}>
      <div className={clsx(styles['filter-container'], styles['filter-keyword'])}>
        <Text size="small" weight="semi-bold" element="p">
          키워드
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            placeholder="선택"
            options={options.searchKeywordTypes}
            value={values.searchKeywordType}
            onChange={(_: unknown, value: TypeSelectOption<string>) => {
              if (value?.value === values.searchKeywordType?.value) return;
              onChange({ searchKeywordType: value, searchKeyword: '' });
              onChangeStatus({ searchKeyword: 'default' });
            }}
          />
          <Input
            type="text"
            size="small"
            placeholder="입력"
            maxLength={50}
            value={values.searchKeyword}
            status={valuesStatus.searchKeyword}
            onChange={(e) => onChange({ searchKeyword: e.target.value })}
            onBlur={(e) => onChange({ searchKeyword: e.target.value.trim() })}
            onFocus={() => onChangeStatus({ searchKeyword: 'default' })}
          />
        </div>
      </div>
      <div className={clsx(styles['filter-container'], styles['filter-date'])}>
        <Text size="small" weight="semi-bold" element="p">
          배송 예정일
        </Text>
        <div className={styles['input-container']}>
          <DatePicker
            size="small"
            placeholder="날짜 선택"
            minDate={dayjs().subtract(3, 'month').startOf('month').toDate()}
            maxDate={getDateByOffset(2, 'day')}
            value={values.estimatedDeliveryDate}
            status={valuesStatus.estimatedDeliveryDate}
            onChange={(value) => onChange({ estimatedDeliveryDate: value })}
            onFocus={() => onChangeStatus({ estimatedDeliveryDate: 'default' })}
          />
        </div>
      </div>
      <div className={clsx(styles['filter-container'], styles['filter-delivery-type'])}>
        <Text size="small" weight="semi-bold" element="p">
          배송 유형
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            placeholder="선택"
            options={[OPTION_ALL, ...options.deliveryTypes]}
            value={values.deliveryType}
            onChange={(_: unknown, value: TypeSelectOption<string>) => onChange({ deliveryType: value })}
          />
        </div>
      </div>
      <div className={clsx(styles['filter-container'], styles['filter-courier'])}>
        <Text size="small" weight="semi-bold" element="p">
          배송사
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            placeholder="선택"
            options={[OPTION_ALL, ...options.courierCodes]}
            value={values.courierCode}
            onChange={(_: unknown, value: TypeSelectOption<string>) => onChange({ courierCode: value })}
          />
        </div>
      </div>
    </SearchFilter>
  );
};

export default DeliveryAgencyOutboundUnitSearchBox;
